import React from 'react';
import ButtonLink from '../../Form/ButtonLink';
import { useNavigate } from 'react-router-dom';

const CardProfileOrders = () => {
    const navigate = useNavigate();

    return (
            <div className='flex flex-col gap-2 w-full'>
                <h4 className='font-semibold'>Últimos pedidos</h4>
                <div className='flex flex-col h-full gap-2'>
                    <div className='w-full h-6 bg-gray-100 rounded-md'></div>
                    <div className='w-full h-6 bg-gray-100 rounded-md'></div>
                    <div className='w-full h-6 bg-gray-100 rounded-md'></div>
                    <div className='w-full h-6 bg-gray-100 rounded-md'></div>
                    <div className='w-full h-6 bg-gray-100 rounded-md'></div>
                </div>
                <div className='flex justify-between'>
                    <ButtonLink onClick={() => navigate('/perfil/meus-pedidos')} className="text-xs">Ver todos</ButtonLink>
                </div>
            </div>
        )
    }

export default CardProfileOrders;